module.exports = __webpack_public_path__ + "static/media/D.bb3a4df4.svg";